import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Model } from '@fry/lib/store';
import { FormWidget, FormField } from '@fry/lib/forms';
import { SortDirection } from '@angular/material/sort';

export const FilterToken = new InjectionToken('FilterToken');

export interface Filter {
    id: string;
    label: string;
    filter?: (item: Model, value: any) => Observable<boolean>;
    widget: FormWidget;
    options?: any;
    initial?: any;
    featured?: boolean;
}

export interface Sort {
  id: string;
  name: string;
  sort?: (itemA: Model, itemB: Model) => number;
}

export type SearchFilter = { [key:string]: any };
export type SearchSort =  { sort_on?: string; sort_order?: SortDirection };
export type SearchSelect = string;
export type SearchOptions = { [key:string]: any };
export type SearchContext = { filter: { [key:string]: any }, user?: string };
export type SearchPagination = { start: number, size: number };
export type TablePart = "columns"|"filters"|"data";

export interface SearchModel {
  filter: SearchFilter;
  sort: SearchSort;
  select?: SearchSelect[] | null;
  pagination?: SearchPagination;
  options?: SearchOptions;
  context?: SearchContext;
}

export interface TableRequest extends SearchModel {
  includeParts?: TablePart[];
}

export interface ListDefaults {
  searchModel?: SearchModel;
  fixedSearchModel?: SearchModel;
  listType?: 'normal' | 'table';
  engine?: 'es' | 'db';
  pageSize?: number;
  exportFormFields?: FormField[];
  hideFilters?: string[],
  featuredFilters?: string[],
  preserveState?: boolean,
}

export interface ListSearch {
    filters(): Observable<Filter[]>;
    sorts(): Observable<Sort[]>;
}
